<template>
  <div>
    <div class="form-group form-check mb-0" :class="hasMarginTop ? 'mt-3' : ''">
      <input
        class="form-check-input checkbpx-input"
        type="checkbox"
        :name="name"
        :value="true"
        v-model="inputVal"
        :id="id"
        :disabled="isDisabled"
        @change="onChangeCheck($event.target.checked)"
      />
      <label class="form-check-label checkbox-label" :for="id" v-html="displayLabel" />
      <p
        class="required-message"
        v-if="!inputVal && submitClicked && isRequired"
      >
        {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
      </p>
    </div>
  </div>
</template>
<script>
// This component include a checkbox and a label
export default {
  name: "CheckboxItem",
  props: {
    name: String,
    value: [Boolean, String],
    label: [String, Object],
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    option: String,
    messageDialogs: Array,
    hasMarginTop: {
      type: Boolean,
      default: true,
    },
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    defaultValue: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.defaultValue) {
      this.$emit("input", this.defaultValue);
    }
  },
  computed: {
    displayLabel() {
      if (typeof this.label === "object") {
        if (this.label.LABEL) {
          return this.label.LABEL;
        }
      }
      return this.label;
    },
    id() {
      return "checkbox-item-" + this._uid + "-" + this.name;
    },
    hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some((button) => button.id === "agency-setting");
    },
    agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find((button) => button.id === "agency-setting");
    },
    inputVal: {
      get() {
        if (this.option) {
          if (this.value == null) {
            return false;
          }
          if (typeof this.value === "string") {
            return this.value.trim() === this.option.trim();
          }
          return this.value === this.option;
        } else {
          return this.value;
        }
      },
      set(val) {
        if (this.option) {
          this.$emit("input", val ? this.option : "");
        } else {
          this.$emit("input", val);
        }
      },
    },
  },
  methods: {
    onChangeCheck(isCheck) {
      // Check to show message dialog
      if (this.messageDialogs && isCheck) {
        const messageDialog = this.messageDialogs.find((item) => item.message);
        if (messageDialog) {
          this.showResultDialog({ innerHtml: messageDialog.message });
          if (!messageDialog.isSelectable) {
            return;
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.checkbpx-input {
  margin-top: 4px;
}

.checkbox-label {
  text-align: left;
  cursor: pointer;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/CheckboxItem.vue